import React, { createContext, useEffect, useState } from "react";

const ReportDetailsContext = createContext({ reportDetails: null, vizState: null });

export function ReportDetailsContextProvider({ children, reportDetails, vizState }) {
  // console.log('vix sssss : ', vizState)
  return (
    <ReportDetailsContext.Provider value={{ reportDetails, vizState }}>
      {children}
    </ReportDetailsContext.Provider>
  );
}

export function useReportDetails() {
  const context = React.useContext(ReportDetailsContext);
  if (context === undefined) {
    throw new Error(
      "useReportDetails must be used within a ReportDetailsProvider"
    );
  }
  return context;
}

// comparison chart context

const ComparisonChartDetailsContext = createContext({ selectedMeasure: [], selectedDimension: null, setSelectedMeasures: () => { }, setSelectedDimension: () => { } });

export function ComparisonChartDetailsContextProvider({ children }) {
  const { reportDetails, vizState } = useReportDetails();
  const [selectedMeasures, setSelectedMeasures] = useState(null);
  const [selectedDimension, setSelectedDimension] = useState(null);
  const [localMeasures, setLocalMeasures] = useState([]);
  const [localDimensions, setLocalDimensions] = useState([]);

  // const [selectedMeasures, setSelectedMeasures] = useState(() => (!measures.length || reportDetails?.reportDetails?.comparisonChartType) ? [] : [measures[0]]);
  // const [selectedDimension, setSelectedDimension] = useState(() => (!dimensions.length || reportDetails?.reportDetails?.comparisonChartType) ? null : dimensions[0]);

  useEffect(() => {
    if (!reportDetails || !vizState) return;

    if (!reportDetails?.comparisonChartType) {
      setSelectedMeasures(null);
      setSelectedDimension(null);
      return;
    }

    let { measures = [], dimensions = [] } = reportDetails;    
    //console.log(vizState)
    if (vizState) {
      const lineAndGroup = [...vizState?.pivotConfig?.lines, ...vizState?.pivotConfig?.group].map(item => item?.text);

      measures = measures.filter(measure => !lineAndGroup.includes(measure.fieldName));
      dimensions = dimensions.filter(dimension => !lineAndGroup.includes(dimension.fieldName));
      //console.log(measures,dimensions);
    }

    if (!selectedMeasures && measures.length) {
      const _selectedMeasure = measures[0];
      if (!selectedMeasures?.fieldName !== _selectedMeasure?.fieldName) setSelectedMeasures(_selectedMeasure);
    }
    if (!selectedDimension && dimensions.length) {
      const _selectedDimension = dimensions[0];
      if (selectedDimension?.fieldName !== _selectedDimension?.fieldName) setSelectedDimension(_selectedDimension);
    }
    setLocalMeasures(measures);
    setLocalDimensions(dimensions);
  }, [reportDetails, vizState]);
  return (
    <ComparisonChartDetailsContext.Provider value={{ selectedMeasures, selectedDimension, setSelectedMeasures, setSelectedDimension, comparisonChartType: reportDetails?.comparisonChartType, measures: localMeasures, dimensions: localDimensions }}>
      {children}
    </ComparisonChartDetailsContext.Provider>
  );
}

export function useComparisonChartDetails() {
  const context = React.useContext(ComparisonChartDetailsContext);
  if (context === undefined) {
    throw new Error(
      "useComparisonChartDetails must be used within a ComparisonChartDetailsProvider"
    );
  }
  return context;
}


// quick fitler context

const QuickFilterContext = createContext({ quickFilterList: [] });

export function QuickFilterContextProvider({ children }) {
  const { reportDetails } = useReportDetails();
  const [quickFilterList, setQuickFilterList] = useState([]);
  useEffect(() => {
    if (!reportDetails) return;
    const { quickFilterList = [] } = reportDetails;
    setQuickFilterList([...quickFilterList]);
  }, [reportDetails?.quickFilterList]);

  const updateQuickFilter = (quickFilter,clearFlag = false) => {
    if(clearFlag){
      setQuickFilterList([...quickFilter]);
    }else{
      const _quickFilterList = [...quickFilterList];
      const index = _quickFilterList.findIndex(_quickFilter => _quickFilter.member === quickFilter.member);
      if (index === -1) return;
      _quickFilterList[index] = quickFilter;
      setQuickFilterList(_quickFilterList);
    }    
  };
  return (
    <QuickFilterContext.Provider value={{ quickFilterList, updateQuickFilter }}>
      {children}
    </QuickFilterContext.Provider>
  );
}

export function useQuickFilter() {
  const context = React.useContext(QuickFilterContext);
  if (context === undefined) {
    throw new Error(
      "useQuickFilter must be used within a QuickFilterProvider"
    );
  }
  return context;
}